export default __webpack_public_path__ + "4a1974473776237fba38632a493d33ef.svg";